import { createSlice } from '@reduxjs/toolkit'
import { removeCookie } from '../../methods/cookies/cookies'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    isAuthenticated: false,
  },
  reducers: {
    addUser: (state, action) => {
      state.user = action.payload 
      state.isAuthenticated = true
    },
    logout: state => {
      removeCookie("launchcore");
      removeCookie("launchcore_refresh");
      state.user = null
      state.isAuthenticated = false
    },
    updateUser: (state, action) => {
      state.user = action.payload 
      state.isAuthenticated = true
    }
  }
})

// Action creators are generated for each case reducer function
export const { addUser, logout, updateUser } = userSlice.actions

export default userSlice.reducer
